import { useEffect, useState } from "react";
import useApiUrlTranslation from "../components/useApiUrlTranslation";

const useGetPartenaires = ({ params }) => {

    const { t, i18n, apiUrlTranslation } = useApiUrlTranslation();

    const [partenaireList, setPartenaireList] = useState(null);

    const [isLoading, setIsLoading] = useState(true);

    const getPartenaires = async () => {

        await fetch(`${apiUrlTranslation}?action=getPartenaires&params=${params}`)
            .then(res => res.json())
            .then(res => setPartenaireList(res))
    }

    useEffect(() => {
        getPartenaires().then(() => {
            setIsLoading(false);
        });

    }, [i18n.resolvedLanguage])

    return { partenaireList, isLoading }
}

export default useGetPartenaires;